export const getMetaobjectsByTypeQuery = `
  query getMetaobjectsByType($type: String!, $first: Int) {
    metaobjects(type: $type, first: $first) {
      edges {
        node {
          id
          handle
          type
          fields {
            key
            value
            reference {
              ... on MediaImage {
                image {
                  url
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const getMetaobjectsByIdsQuery = `
  query getMetaobjectsByIds($ids: [ID!]!) {
    nodes(ids: $ids) {
      ... on Metaobject {
        handle
        id
        type
        fields {
          key
          value
          reference {
            ... on MediaImage {
              image {
                url
              }
            }
            ... on Metaobject {
              id
              handle
              type
              fields {
                key
                value
                reference {
                  ... on MediaImage {
                    image {
                      url
                    }
                  }
                  ... on Metaobject {
                    id
                    handle
                    type
                    fields {
                      key
                      value
                      reference {
                        ... on MediaImage {
                          id
                          image {
                            url
                          }
                        }
                      }
                      references(first: 20) {
                        edges {
                          node {
                            ... on MediaImage {
                              id
                              image {
                                url
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
                references(first: 20) {
                  edges {
                    node {
                      ... on MediaImage {
                        id
                        image {
                          url
                        }
                      }
                    }
                  }
                }
              }
            }
            ... on ProductVariant {
              id
              title
              variantImage: image {
                url
                altText
              }
              product {
                title
                handle
              }
            }
          }
          references(first: 20) {
            edges {
              node {
                ... on Metaobject {
                  id
                  handle
                  type
                  fields {
                    key
                    value
                    reference {
                      ... on MediaImage {
                        image {
                          url
                        }
                      }
                    }
                    references(first: 20) {
                      edges {
                        node {
                          ... on ProductVariant {
                            id
                            title
                            variantImage: image {
                              url
                              altText
                            }
                            product {
                              title
                              handle
                            }
                          }
                        }
                      }
                    }
                  }
                }
                ... on ProductVariant {
                  id
                  title
                  variantImage: image {
                    url
                    altText
                  }
                  product {
                    title
                    handle
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const getCityWithStoresQuery = `
  query getCityWithStores($handle: String!, $type: String!) {
    metaobject(handle: { handle: $handle, type: $type }) {
      handle
      id
      type
      fields {
        key
        value
        reference {
          ... on MediaImage {
            image {
              url
            }
          }
          ... on Metaobject {
            id
            handle
            type
            fields {
              key
              value
              reference {
                ... on MediaImage {
                  image {
                    url
                  }
                }
              }
            }
          }
          ... on ProductVariant {
            id
            title
            product {
              title
              handle
            }
          }
        }
        references(first: 20) {
          edges {
            node {
              ... on Metaobject {
                id
                handle
                type
                fields {
                  key
                  value
                  reference {
                    ... on MediaImage {
                      image {
                        url
                      }
                    }
                  }
                  references(first: 20) {
                    edges {
                      node {
                        ... on ProductVariant {
                          id
                          title
                          product {
                            title
                            handle
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const getMetaobjectByHandleQuery = `
  query getMetaobjectByHandle($handle: String!, $type: String!) {
    metaobject(handle: { handle: $handle, type: $type }) {
      id
      handle
      type
      fields {
        key
        type
        value
        reference {
          ... on Metaobject {
            id
            handle
            type
            fields {
              key
              type
              value
              reference {
                ... on Metaobject {
                  id
                  handle
                  type
                  fields {
                    key
                    type
                    value
                  }
                }
                ... on MediaImage {
                  id
                  image {
                    url
                    altText
                    width
                    height
                  }
                }
                ... on GenericFile {
                  id
                  url
                }
              }
            }
          }
          ... on MediaImage {
            id
            image {
              url
              altText
              width
              height
            }
          }
          ... on GenericFile {
            id
            url
          }
        }
        references(first: 250) {
          edges {
            node {
              ... on Metaobject {
                id
                handle
                type
                fields {
                  key
                  type
                  value
                  reference {
                    ... on Metaobject {
                      id
                      handle
                      type
                      fields {
                        key
                        type
                        value
                        reference {
                          ... on MediaImage {
                            id
                            image {
                              url
                              altText
                              width
                              height
                            }
                          }
                          ... on GenericFile {
                            id
                            url
                          }
                        }
                        references(first: 50) {
                          edges {
                            node {
                              ... on MediaImage {
                                id
                                image {
                                  url
                                  altText
                                }
                              }
                              ... on GenericFile {
                                id
                                url
                              }
                            }
                          }
                        }
                      }
                    }
                    ... on MediaImage {
                      id
                      image {
                        url
                        altText
                        width
                        height
                      }
                    }
                    ... on GenericFile {
                      id
                      url
                    }
                  }
                  references(first: 50) {
                    edges {
                      node {
                        ... on MediaImage {
                          id
                          image {
                            url
                            altText
                          }
                        }
                        ... on GenericFile {
                          id
                          url
                        }
                      }
                    }
                  }
                }
              }
              ... on MediaImage {
                id
                image {
                  url
                  altText
                  width
                  height
                }
              }
              ... on GenericFile {
                id
                url
              }
            }
          }
        }
      }
    }
  }
`;

export const resolveFilesQuery = `
  query resolveFiles($ids: [ID!]!) {
    nodes(ids: $ids) {
      ... on MediaImage {
        id
        image {
          url
        }
      }
      ... on GenericFile {
        id
        url
      }
      ... on Video {
        id
        sources {
          url
        }
      }
    }
  }
`;
